import React, { useState } from 'react';

const defaultValue = {
  planoContasId: '',
  planoContasUtilizado: '',
  dreReceitaList: [],
  dreDespesaList: [],
  categoria: {},
  classesReceita: [],
  classesDespesa: [],
  vinculosAutomaticos: {},
  classesAnaliticoSintetico: {
    receita: {
      analitico: [],
      sintetico: [],
    },
    despesa: {
      analitico: [],
      sintetico: [],
    },
  },
  dialogOpen: false,
  loading: true,
};

export const CategoriaContext = React.createContext({});

export const CategoriaProvider = (props) => {
  return (
    <CategoriaContext.Provider
      value={{
        dreReceitaList: useState(defaultValue.dreReceitaList),
        dreDespesaList: useState(defaultValue.dreDespesaList),
        categoria: useState(defaultValue.categoria),
        classesReceita: useState(defaultValue.classesReceita),
        classesDespesa: useState(defaultValue.classesDespesa),
        vinculosAutomaticos: useState(defaultValue.vinculosAutomaticos),
        dialogOpen: useState(defaultValue.dialogOpen),
        classesAnaliticoSintetico: useState(defaultValue.classesAnaliticoSintetico),
        planoContasId: useState(defaultValue.planoContasId),
        planoContasUtilizado: useState(defaultValue.planoContasUtilizado),
        loading: useState(defaultValue.loading),
      }}
    >
      {props.children}
    </CategoriaContext.Provider>
  );
};

export const CategoriaConsumer = CategoriaContext.Consumer;
